import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectSoftwareEmbedRoute: InvariantJiraRoute = {
	name: 'software-issue-navigator-embed',
	path: '/jira/software/projects/:projectKey/issues/embed',
};
